import { useEffect, useState } from "react";
import api from "@/lib/api";

// Platform admin: per-business WhatsApp connection health. Masked data only — never tokens or secrets.
export const PlatformWhatsAppConnections = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/platform/whatsapp/connections").then((r) => setD(r.data)).catch(() => setD({ error: true })); }, []);
  if (!d) return null;
  if (d.error) return <p className="mt-6 text-xs text-rose-600" data-testid="pa-wa-error">Could not load WhatsApp connections.</p>;
  return (
    <div className="mt-6 rounded-xl border border-slate-800 bg-slate-900 p-4 text-slate-300" data-testid="pa-wa-connections">
      <p className="text-sm font-semibold text-white">WhatsApp connections</p>
      <p className="mt-1 text-xs text-slate-500" data-testid="pa-wa-counts">
        Connected {d.counts.connected} · Reconnect required {d.counts.token_invalid} · Key unavailable {d.counts.key_unavailable} · Disconnected {d.counts.disconnected}
        {d.platform_missing.length > 0 && <span className="ml-2 text-amber-700">Platform settings missing: {d.platform_missing.join(", ")}</span>}
      </p>
      <table className="mt-3 w-full text-left text-xs">
        <thead className="text-slate-500"><tr><th>Business</th><th>Status</th><th>Number</th><th>Invoice template</th><th>Notification templates</th><th>Live</th><th>Key current</th></tr></thead>
        <tbody>
          {d.connections.map((c) => (
            <tr key={c.tenant_id} className="border-t border-slate-800" data-testid={`pa-wa-row-${c.tenant_id}`}>
              <td>{c.tenant_name || c.tenant_id}</td><td>{c.status}{c.last_error && <span className="block text-rose-600">{c.last_error}</span>}</td>
              <td>{c.display_phone}</td><td>{c.invoice_template_ok ? "Ready" : "Not ready"}</td><td>{c.notification_templates_ready}</td>
              <td>{c.live_enabled ? "On" : "Off"}</td><td>{c.token_on_current_key ? "Yes" : "No"}</td>
            </tr>
          ))}
          {!d.connections.length && <tr><td colSpan={7} className="py-2 text-slate-500">No businesses have connected WhatsApp yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};
